/**
 * The `legacy` area: statements the resolver no longer produces, which rows
 * already in the log still hold as English sentences. Only the legacy parser
 * (src/domain/resolution/legacy-statement.ts) returns these keys, so a stored
 * sentence formats in the reader's language. Delete this area with the parser,
 * once no stored row predates the descriptor.
 */
export const legacy = {
  // The tick table before 2026-09-22: a doer's tick waited on the requester,
  // and an owner's close could be deferred.
  'legacy.statement.deliveredWaitsOnRequester': "Marked done; waits on the requester's close.",
  'legacy.statement.seatedDeliveredWaitsOnRequester':
    "Seated as contributor and marked done; waits on the requester's close.",
  'legacy.statement.deliveredClosesOnReview': 'Marked done; closes when the review lands.',
  'legacy.statement.deliveredClosesWithSubTasks': {
    one: 'Marked done; closes when the {count} sub-item closes.',
    other: 'Marked done; closes when the {count} sub-items close.',
  },
  'legacy.statement.subTasksDoneClosing': 'The sub-items are done: closing, as deferred.',
  'legacy.statement.reviewLandedClosing': 'The review landed: closing, as deferred.',
  // The conclusion before 2026-09-21's question: a statement plus how many
  // locked sub-tasks stayed open ("stays" whatever the count).
  'legacy.statement.withLockedStaying': '{statement} {count} stays open.',
} as const;
